import { normalize_key } from './case_domains_common';

const DOMAIN_BADGES = [
  { keys: ['legal', 'safety'], badge: 'is-rose' },
  { keys: ['service'], badge: 'is-violet' },
  { keys: ['oversight'], badge: 'is-amber' },
  { keys: ['hr', 'human'], badge: 'is-mint' }
];
const DEFAULT_BADGES = ['is-blue', 'is-rose', 'is-violet', 'is-amber', 'is-mint'];

export function badge_class_for_domain(name = '', index = 0) {
  const key = normalize_key(name);
  const match = DOMAIN_BADGES.find((item) =>
    item.keys.some((domain_key) => key.includes(domain_key))
  );
  return match?.badge || DEFAULT_BADGES[index % DEFAULT_BADGES.length];
}
